module.exports = __webpack_public_path__ + "static/assets/da9c3c07aa7ed5f37fd576a07a5a2bc4.png";